export const menuConstants = {
    USER_MENU_REQUEST:   'USER_MENU_REQUEST',
    USER_MENU_SUCCESS:   'USER_MENU_SUCCESS',
    USER_MENU_FAILURE:   'USER_MENU_FAILURE',
};
